const fn = {
  init: () => {
    fn.setupPageHeaderMediaSlider()
  },

  setupPageHeaderMediaSlider: () => {
    const headerContainer = document.querySelector('.has-media-slider-header .page-header-container')

    const contentContainer = document.querySelector('.has-media-slider-header .section-content')

    if (!headerContainer || !contentContainer) {
      return
    }

    const handleOffset = () => {
      const headerTop = headerContainer.getBoundingClientRect().top
      const contentTop = contentContainer.getBoundingClientRect().top
      const headerPadding = parseInt(window.getComputedStyle(headerContainer).paddingTop, 10)
      const offset = contentTop - headerTop - headerPadding + 72

      headerContainer.closest('.has-media-slider-header').style.setProperty('--top-offset', `-${offset}px`)
    }

    window.addEventListener('resize', handleOffset)

    handleOffset()
  },
}

export default {
  can: () => true,
  run: fn.init,
}
